<script lang="ts">
    import type {StaticSearchParams} from 'typings/portaro.be.types';
    import {getLocalization} from 'core/svelte-context/context';
    import {exists} from 'shared/utils/custom-utils';
    import KpSearchContext from '../kp-search-context/KpSearchContext.svelte';
    import KpGenericPageContainer from 'shared/layouts/KpGenericPageContainer.svelte';
    import KpSearch from 'src/features/search/kp-search/KpSearch.svelte';
    import KpGenericPanel from 'shared/ui-widgets/panel/KpGenericPanel.svelte';

    export let pageClass: string;
    export let staticParams: Partial<StaticSearchParams> | undefined;
    export let localSearch = false;

    const localize = getLocalization();
</script>

<KpGenericPageContainer additionalClasses="kp-search-page-container-with-context-actions {pageClass}">
    <KpSearchContext {staticParams} {localSearch} let:searchManager>
        <KpSearch {searchManager}>
            <svelte:fragment slot="additional-side-content">
                {#if exists($$slots['context-actions'])}
                    <KpGenericPanel>
                        <span slot="heading">
                            {localize(/* @kp-localization commons.Options */ 'commons.Options')}
                        </span>

                        <div class="context-actions">
                            <slot name="context-actions" {searchManager}/>
                        </div>
                    </KpGenericPanel>
                {/if}
            </svelte:fragment>
        </KpSearch>
    </KpSearchContext>
</KpGenericPageContainer>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";

    .context-actions {
        display: flex;
        flex-direction: column;
        gap: @spacing-sm;
    }

    :global {
        .kp-search-page-container-with-context-actions .context-actions > button,
        .kp-search-page-container-with-context-actions .context-actions > a {
            width: 100%;
            margin-bottom: 0;
        }

        .kp-search-page-container-with-context-actions .context-actions > .kp-dropdown-button {
            width: 100%;

            button {
                width: 100%;
            }
        }
    }
</style>
